<script lang="ts">
  import { onMount } from "svelte";
  import FnEditor from "../fnEditor/FnEditor";

  let ref: HTMLElement;
  let editable: FnEditor | undefined;

  export let screenplay: string;
  export let identifier: string;
  export let currentIndex: number|undefined;
  export let setScreenplay: (string: string) => void;
  export let toggleUnsavedChanges: () => void;
  export let updateIndex: (index?: number) => void;

  export const transferToParent = () => {
    setScreenplay(editable.save().map((line) => {return line.text}).join("\n"));
  };

  onMount(() => {
    editable = new FnEditor(
      ref,
      identifier,
      screenplay.split(/\r?\n/).map((line) => {return {text: line}}),
    );

    editable.onSaveStateChange((isSaved: boolean) => {
      if (true === isSaved) {
        // Ctrl + S os already handled in parent and calls transferToParent()
      } else {
        toggleUnsavedChanges()
      }
    })

    return () => {
      editable.destroy();
    };
  });
</script>

<div
  class="ScreenplayLiveMarginEditor"
  spellcheck={false}
  bind:this={ref}
/>

<style type="text/scss">
  :global(.fn-history li) {
    padding: 10px 0;
    display: block;
    border-bottom: 1px #ccc dashed;
  }
  :global(.fn-history strong) {
    display: block;
  }
  :global(.fn-history) {
      background: #fff;
      border-left: 1px #ccc solid;
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      height: 100%;
      width: min(70vw, 300px);
      z-index: 9999998;
      list-style: none;
      padding: 45px 15px 0 15px;
      margin: 0;
      
    }
    :global(.fn-history-close) {
      background: #fff;
      border: 1px #ccc solid;
      position: fixed;
      top: 5px;
      right: 5px;
      z-index: 9999999;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-style: inherit;
      cursor: pointer;
    }
  :global(.fn-navigator) {
    background: #fff;
    border-left: 1px #ccc solid;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: min(70vw, 300px);
    z-index: 9999998;
    list-style: none;
    padding: 45px 15px 0 15px;
    margin: 0;
    overflow: scroll;
  }
  :global(.fn-navigator h2) {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.2;
    margin: 10px 0 2px 0;
    text-transform: uppercase;
  }
  :global(.fn-navigator span) {
    font-size: 12px;
    line-height: 1.4;
    margin-right: 5px;
  }
  :global(.fn-navigator-close) {
    z-index: 9999999;
    position: absolute;
    top: 5px;
    right: 5px;
    background: #fff;
    border: 1px #ccc solid;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-style: inherit;
    cursor: pointer;
  }
  .ScreenplayLiveMarginEditor {
    width: 8.5in;
    font-family: "sans_regular", sans-serif;
    box-sizing: border-box;
    padding: 30px 1in;
    font-size: 16px;
    outline: none;
    border: 1px dashed #c1c1c1;
    margin: 10px auto;
    background: #fff;
    line-height: 22px;
    :global(.fn-editor-element) {
      min-height: 22px;
      box-sizing: content-box;
    }
    :global(.fn-editor-element--scene-heading) {
      text-transform: uppercase;
      font-weight: bold;
    }

    :global(.fn-editor-element--character) {
      padding-left: 1.7in;
    }

    :global(.fn-editor-element--dialogue) {
      padding-left: 1in;
      max-width: 3.5in;
    }

    :global(.fn-editor-element--parenthetical) {
      padding-left: 1.1in;
    }

    :global(.fn-editor-element--centered-action) {
      text-align: center;
    }

    :global(.fn-editor-element--transition) {
      text-align: right;
    }

    :global(.fn-editor-element--lyrics) {
      text-align: center;
      padding: 0 10%;
    }

    :global(.fn-editor-element--section) {
      color: #9c1171;
    }

    :global(.fn-editor-element--synopsis) {
      font-size: 15px;
    }

    :global(.fn-editor-element--synopsis .synopsis-indicator) {
      color: rgb(187, 187, 187);
    }

    :global(.fn-editor-element--page-break) {
      border-bottom: 1px solid #e8e8e8;
      position: relative;
      &:before {
        position: absolute;
        left: 0;
        top: 23px;
        display: block;
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 6.5px 0 6.5px;
        border-color: #e8e8e8 transparent transparent transparent;
      }
    }

    :global(.emphasis--bold) {
      font-weight: bold;
    }
    :global(.emphasis--italics) {
      font-style: italic;
    }
    :global(.emphasis--bold-italics) {
      font-style: italic;
      font-weight: bold;
    }
    :global(.emphasis--underline) {
      text-decoration: underline;
    }
    :global(.em-char) {
      color: rgb(187, 187, 187);
    }
    :global(.emphasis--note) {
      color: #57d0d6;
    }
    :global(.fn-editor-element--image span) {
        color: rgb(187, 187, 187);
    }
  }
</style>
